import type { CountryType, Nullable } from "../@types/generic";

export const availableCountries = [
    "at", // Austria
    "ch", // Switzerland
    "cs", // Czech
    "da", // Danish
    "de", // German
    "es", // Spanish
    "fr", // French
    "it", // Italian
    "nl", // Dutch
    "pl", // Polish
    "ro", // Romanian
    "sk", // Slovak
    "sv", // Swedish
    "uk", // English UK
    "us", // English US
] as const;

export const isAvailableCountry = (
    country?: Nullable<string>
): country is CountryType => {
    return availableCountries.includes(country as CountryType);
};
